module.exports = __webpack_public_path__ + "img/title_lfm2.6f58a2e6.png";